/**
 * 活跃趋势 — GET /api/admin/stats/trends/active-logins
 */
import { Table } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { api } from '../../api/client';

export function TrendActivePage() {
  const { data, isLoading } = useQuery({
    queryKey: ['admin', 'stats', 'trends', 'active'],
    queryFn: () =>
      api.get<{ rows: { day: string; count: number }[] }>(
        '/api/admin/stats/trends/active-logins?days=30',
      ),
  });

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>活跃趋势</h2>
      <p style={{ color: '#666' }}>近 30 日按 UTC 日切分、以 last_login_at 统计的登录次数（非去重人数）。</p>
      <Table
        loading={isLoading}
        size="small"
        rowKey="day"
        pagination={false}
        dataSource={data?.rows ?? []}
        columns={[
          { title: '日期 (UTC)', dataIndex: 'day', width: 140 },
          { title: '登录次数', dataIndex: 'count' },
        ]}
      />
    </div>
  );
}
